import { API } from '~apis/axios/instance';
import { CashFlowType } from '~models/cashFlow';
import { ResponseBaseWithData } from '~types/response';

export interface Category {
  categoryId: number;
  category0: string | null;
  category1: string;
  category2: string;
  category3?: string;
  companyDetailedCategory?: string;
  companyDetailedCategorySequenceNumber?: number;
  companyDetailedCategoryId?: number;
  cashFlowType: CashFlowType;
  needMapping: boolean;
  hasBusinessEntity: boolean;
  isCardPayment: boolean;
  isUnClassified: boolean;
  description: string;
  categoryLabelKey: string;
  contraCategoryId: null | number;
}
export interface GetCategoriesResponse {
  categories: Category[];
}

interface CompanyIdentifier {
  companyId: string;
}

export const getCategories = ({ companyId }: CompanyIdentifier) => {
  return API.get<ResponseBaseWithData<GetCategoriesResponse>>(
    `/api/v3/companies/${companyId}/categories`,
  );
};
